import React from "react";
import CsLineIcons from "../../cs-line-icons";

class DropdownItem extends React.Component
{
    onClick = (e) => {
        if (!this.props.onClick) return;
        this.props.onClick(e, this.props);
        this.props.onAfterClick?.();
    }

    render() {
        if (this.props.divider) {
            return <div className="dropdown-divider" />;
        }

        return (
            <button type="button" className="dropdown-item d-flex align-items-start gap-2 py-2" onClick={this.onClick}>
                {this.props.icon ? (
                    <CsLineIcons icon={this.props.icon} className="text-primary mt-1 flex-shrink-0" />
                ) : null}
                <span className="d-flex flex-column text-start">
                    <span>{this.props.caption}</span>
                    {this.props.description ? (
                        <small className="text-muted lh-sm">{this.props.description}</small>
                    ) : null}
                </span>
            </button>
        );
    }
}

export default DropdownItem;
